<template>
    <v-card class="panelBlock ma-2 conduct-terms">
        <v-layout row wrap>
            <v-flex xs12 tag="h2">{{myToolsConstants.LEARNING_DIRECTORY}}</v-flex>
            <v-flex :class="['resources__list-items', showProgress ? 'loading-state' : '']">
                <span class="learning" v-if="!showProgress" data-qe-id="learning_journey" @click="openLMSSite()">{{myToolsConstants.MY_LEARNING}}
                </span>
                <v-progress-circular v-else indeterminate color="ypo-blue" size="28" ></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
    import { myToolsConstants } from "../Tools/mytools.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { mapActions } from "vuex";
    import { routerNames, appCommonConstants } from "../appCommon.constants";
    import store from "../../store/store";
    import { storeMutation } from "../../store/storeMutations.constant";

    export default {
        name: "MyLearning",
        data: () => ({
            myToolsConstants,
            showProgress: false,
        }),
        methods: {
            ...mapActions({
               registerInAdobe: `auth/${storeAction.registerInAdobe}`,
            }),
            openLMSSite() {
                this.showProgress = true;
                this.registerInAdobe()
                    .then((response) => {
                        if (response && response.data) {
                            window.open(`${appCommonConstants.ADOBE_LMS_URL}`, '_blank');
                            this.showProgress = false;
                        } else {
                            store.commit(`ypoError/${storeMutation.setYpoErrorData}`, 1, { root: true });
                            this.$router.push({
                                path: `/${routerNames.ERROR_PAGE}`,
                            });
                            this.showProgress = false;
                        }
                    });
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .learning {
        color: $ypo-cta;
        font-size: 14px;
        font-weight: bold;
        line-height: 19px;
        cursor: pointer;
    }

    .loading-state {
        text-align: center;
    }

</style>
